export default {"src":"/_next/static/media/college6.dc00afb5.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};